<template lang="html">
  <div class="editor">
    <div id="wangEditor">
    </div>
    <div class="limitNum">已填写{{ spanInfo }}字 <span v-if="timeInt">上次保存时间{{initTime(timeInt)}}</span></div>
  </div>
</template>

<script>
import axios from "axios";
import E from "wangeditor";
import appConfig from "../../app.config";
export default {
  name: "WangEditor",
  data() {
    return {
      // uploadPath,
      editor: null,
      info_: null,
      spanInfo: 0,
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    isClear: {
      type: Boolean,
      default: false,
    },
    timeInt: {
      type: [String, Number],
      default: "",
    },
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear();
        this.info_ = null;
      }
    },
    value: function (value) {
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
      }
      var temp = this.value.replace(/<\/?.+?>/g, "");
      var result = temp.replace(/ /g, ""); //result为获取冲文字得到后的内容
      this.spanInfo = result.length;
    },
    //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  mounted() {
    this.seteditor();
    this.editor.txt.html(this.value);
  },
  methods: {
    seteditor() {
      this.editor = new E("#wangEditor");
      this.editor.config.uploadImgShowBase64 = false; // base 64 存储图片
      this.editor.config.uploadImgServer = `${appConfig.apiPath}/oss/uploadPicture`; // 配置服务器端地址
      this.editor.config.uploadImgHeaders = {}; // 自定义 header
      this.editor.config.uploadFileName = "file"; // 后端接受上传文件的参数名
      this.editor.config.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      this.editor.config.customUploadImg = (files, insert) => {
        // console.log(files[0]);
        // files 是 input 中选中的文件列表
        // insert 是获取图片 url 后，插入到编辑器的方法
        let f = new FormData(); // 创建form对象
        // for (var i = 0; i < files.length; i++) {
        //   param.append("fileList", files[i], files[i].name);
        // }
        // const url = `${appConfig.apiPath}/oss/uploadPicture`; // url是上传图片的路径
        // // 一般项目中都会封装好发送请求得方法,我这为了通用直接用axios
        // const apiSecret = "3ae4c8f7f96dc88813c0aa8c0a2988e1";
        // let headers = Object.assign({
        //   secret: apiSecret,
        //   "Content-Type": "multipart/form-data",
        // });
        // axios.post(url, param, { headers }).then((res) => {
        //   let data = res.data;
        //   if (data.code === 200) {
        //     let result = data.data.split(",");
        //     for (let i = 0; i < result.length; i++) {
        //       let url = result[i];
        //       insert(url);
        //     }
        //   }
        f.append("imgFile", files[0]);
        try {
          // console.log(f);
          this.$axios({
            headers: {
              "Content-Type": "multipart/form-data",
              token: appConfig.apiToken,
            },
            method: "post",
            url: appConfig.apiPath + "/oss/uploadPicture",
            data: f,
          })
            .then((res) => {
              insert(this.ossUrl + res.data.data);
            })
            .catch((error) => {
              this.$message.error("上传失败！服务器错误！");
            });
        } catch (e) {}
      };

      // 配置菜单
      this.editor.config.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        // 'emoticon', // 表情
        "image", // 插入图片
        "table", // 表格
        "undo", // 撤销
        "redo", // 重复
      ];
      this.editor.config.height = 500;
      // this.editor.config.showFullScreen = false
      this.editor.config.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
        },

        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功，插入图片的回调
          //result为上传图片成功的时候返回的数据，这里我打印了一下发现后台返回的是data：[{url:"路径的形式"},...]
          // console.log(result.data[0].url)
          //insertImg()为插入图片的函数
          let dataList = data.split(",");
          for (let i = 0; i < dataList.length; i++) {
            let url = dataList[i];
            insertImg(url);
          }
        },
      };
      this.editor.config.onchange = (html) => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
      };
      // 创建富文本编辑器
      this.editor.create();
      // 修复编辑器中文状态下输入第一个字符删除
      this.editor.cmd.do("insertHTML", "&ZeroWidthSpace;");
      // this.editor.config.onchange = str => {
      //     console.log(str, "str")
      //     if(!str){
      //         if(this.editor.$textElem.elems[0].innerHTML === '<p data-we-empty-p=""><br></p>'){
      //             this.editor.cmd.do('insertHTML', '&ZeroWidthSpace;');
      //         }
      //     }
      // }
    },
    initTime(timeInt) {
      let time = new Date(timeInt * 1000);
      let resutlt = dateFormat("YYYY-mm-dd HH:MM:SS", time);
      return resutlt;
    },
  },
   beforeDestroy() {
    // 销毁编辑器
    this.editor.destroy()
    this.editor = null
  }
};
</script>

<style lang="css">
.editor {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 0;
}
.editor .toolbar {
  border: 1px solid #ccc;
}
.editor .text {
  border: 1px solid #ccc;
  /* min-height: 500px; */
}

.editor .limitNum {
  width: 100%;
  line-height: 30px;
  padding-left: 6px;
  color: #666;
}
</style>